module.exports = __webpack_public_path__ + "img/ChartBar.d9517d7e.svg";